import {
  SearchDropdownType,
  SearchFieldElement,
} from "@/app/layouts/standard/header/search-bar/search-bar-dropdown/searchFieldDropdown";
import CloseIcon from "public/next-public/common/icons/close-icon.svg";
import { MouseEvent } from "react";
import styles from "./searchFieldDropdown.module.scss";

export const SearchFieldDropdownElement = ({
  elementDetails,
  dropdownItemChooseCallback,
  dropdownItemDismissCallback,
}: SearchFieldDropdownElementProps) => {
  function handleDissmissClick(
    event: React.MouseEvent<SVGSVGElement, MouseEvent>,
    elementDetails: SearchFieldElement,
  ): void {
    event.preventDefault();
    event.stopPropagation();
    if (dropdownItemDismissCallback) {
      dropdownItemDismissCallback(elementDetails);
    }
  }

  return (
    <div
      className={`${styles["dropdownElementContainer"]} ${elementDetails.dropdownType === SearchDropdownType.LOCAL_HISTORY ? styles["historyElement"] : ""}`}
      onClick={(event) => {
        event.stopPropagation();
        dropdownItemChooseCallback(elementDetails);
      }}
    >
      {!elementDetails.unboldedQuery ? (
        elementDetails.label
      ) : (
        <>
          <span className={styles["suggestionPrefix"]}>{elementDetails.prefix}</span>
          <span className={styles["suggestionBold"]}>{elementDetails.unboldedQuery}</span>
          <span className={styles["suggestionSuffix"]}>{elementDetails.suffix}</span>
        </>
      )}
      {elementDetails.dropdownType === SearchDropdownType.LOCAL_HISTORY && (
        <CloseIcon
          className={styles["clearButtonSVG"]}
          width="16px"
          height="16px"
          fill="currentColor"
          onClick={(event: React.MouseEvent<SVGSVGElement, MouseEvent>) => handleDissmissClick(event, elementDetails)}
        />
      )}
    </div>
  );
};

type SearchFieldDropdownElementProps = {
  elementDetails: SearchFieldElement;
  dropdownItemChooseCallback: (elementDetails: SearchFieldElement) => void;
  dropdownItemDismissCallback?: (elementDetails: SearchFieldElement) => void;
};
